<template>
  <main class="jobs">

    <!-- Header -->
    <theme-header />

    <!-- Banner -->
    <banner-one />

    <!-- Badges -->
    <all-badges />
    
    <!-- GetStarted -->
    <get-started />

    <!-- Footer -->
	<theme-footer />


	<!-- Back To Top -->
	<back-to-top btnText="Back to top" :showIcon="true" />
    
  </main>
</template>

<script>
// @ is an alias to /src
import ThemeHeader from '@/components/common/ThemeHeader.vue';
import BannerOne from '@/components/banners/BannerOne.vue';
import GetStarted from '../components/sections/GetStarted.vue';
import ThemeFooter from '../components/common/ThemeFooter.vue';
import BackToTop from '../components/pieces/BackToTop.vue';
import AllBadges from '../components/sections/AllBadges.vue';

export default {
  name: 'Jobs',
  components: {
    ThemeHeader,
    BannerOne,
    GetStarted,
    ThemeFooter,
    BackToTop,
    AllBadges
  }
}
</script>,
